import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'
import { InputText } from 'primereact/inputtext'
import { Button as ButtonPrime } from 'primereact/button'
import { Row, Col, Label, Button } from 'reactstrap'

import useTablePaginationConfig from '../../../../hooks/useTablePaginationConfig'
import CustomModal, { useModal } from '../../../../common/CustomModal/CustomModal'
import { closeModal } from '../../../../common/GlobalModal/redux/GlobalModalActions'
import CustomPrimeTable from '../../../../common/PrimeTable/CustomPrimeTable'
import { getAllLessee, getContact, createLessee } from '../../redux/ContactActions'
import useGetStates from '../../../../hooks/useGetStates'
import useGetSupportTable from '../../../../hooks/useGetSupportTable'
import { NATIONALITY } from '../../../../constants/supportTypes'
import { MOTOR_CARRIER } from '../../../../constants/entityTypes'
import CustomSelect from '../../../../common/CustomReactSelectComponent'
import Loader from '../../../Loader/index'
import { CustomInputMask, CustomInputText } from '../../../../common/CustomInputs/CustomInputs'
import { notificationDangerCustomTime, notificationSuccess } from '../../../../utils/customToastify'

const ChangeLessee = () => {
  const dispatch = useDispatch()
  const stateOptions = useGetStates({ isAbbreviation: false })
  const nationalityOptions = useGetSupportTable(NATIONALITY)
  const { options, onPageChange, onFilterChange, onSortChange } = useTablePaginationConfig({}, { limit: 10, first: 0 })
  const { isModalOpen, toggleModal } = useModal()
  const { data, query, errors, contactId, divisionId } = useSelector((state) => ({
    data: state.contacts?.lessee?.allLessee?.data,
    query: state.contacts?.lessee?.allLessee?.query,
    errors: state.errors,
    contactId: state.contacts.contact.id,
    divisionId: state.auth.user.division_id,
  }))
  const [isLoading, setIsLoading] = useState(false)
  const [name, setName] = useState('')
  const [lesseeData, setLesseeData] = useState({})

  useEffect(() => {
    loadData()
  }, [options])

  const loadData = async () => {
    setIsLoading(true)
    await dispatch(getAllLessee({ ...options, tableFilter: { ...options.tableFilter, name } }))
    setIsLoading(false)
  }

  const handleChange = (e) => {
    setName(e.target.value)
  }

  const handleChangeLesseeData = (e) => {
    const { name, value } = e.target
    setLesseeData({ ...lesseeData, [name]: value })
  }

  const handleChangeLesseeDataSelect = (value, e) => {
    setLesseeData({ ...lesseeData, [e.name]: value ? value.id || value.value : null })
  }

  const changeLessee = async (e) => {
    try {
      setIsLoading(true)
      await axios.patch(`/contacts/lessee/${contactId}`, { lessee: e.value.id, id: contactId })
      setIsLoading(false)
      notificationSuccess('Lessee successfuly changed!')
      dispatch(closeModal('change_lessee'))
      dispatch(getContact(contactId, divisionId))
    } catch (err) {
      setIsLoading(false)
      notificationDangerCustomTime('Operation didn`t succeed, something went wrong!', 10000)
    }
  }

  const saveLessee = async () => {
    try {
      setIsLoading(true)
      const data = { ...lesseeData, organizationTypeId: MOTOR_CARRIER }
      await dispatch(createLessee(data, options, toggleModal))
      // toggleModal()
      setIsLoading(false)
    } catch (err) {
      setIsLoading(false)
    }
  }

  const columns = [{ field: `name`, header: 'Name' }]

  let loader = null
  if (isLoading) loader = <Loader />

  return (
    <>
      <Row>
        <Col md='7'>
          <Label className='d-block mb-2'>Search by Name</Label>
          <div className='p-inputgroup'>
            <InputText placeholder='Search...' className='p-inputtext-sm' value={name} onChange={handleChange} />
            <ButtonPrime icon='pi pi-search' className='p-button-warning p-button-sm' onClick={loadData} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
      {loader}
      <Row>
        <Col>
          <CustomPrimeTable
            data={data}
            selectRows={false}
            findHidden={true}
            // getSelectedRows={getSelectedRows}
            columns={columns}
            onPage={onPageChange}
            onSort={onSortChange}
            addHidden={false}
            onFilter={onFilterChange}
            onSelectionChange={(e) => {
              changeLessee(e)
            }}
            pageSize={10}
            query={query}
            onAdd={() => toggleModal()}
            newTab={true}
            showActions={false}
          />
        </Col>
      </Row>
      <CustomModal isOpen={isModalOpen} toggle={toggleModal} medium headerText='Add Lessee'>
        <Row className='mt-4'>
          <Col md='6'>
            <CustomInputText
              label='MC Number'
              value={lesseeData.mcNumber}
              onChange={handleChangeLesseeData}
              name={'mcNumber'}
              placeholder={'MC Number'}
              errorMess={errors.mcNumber}
            />
          </Col>
          <Col md='6'>
            <CustomSelect
              isMulti={false}
              label='Preferred Language'
              placeholder='Select...'
              name='nationalityId'
              onChange={handleChangeLesseeDataSelect}
              defaultValue={lesseeData.nationalityId || 0}
              options={nationalityOptions}
              isClearable
              invalid={!!errors.nationalityId}
              errorMess={errors.nationalityId}
            />
          </Col>
        </Row>
        {loader}
        <Row className='mt-2'>
          <Col md='6'>
            <CustomInputText
              label='Name'
              value={lesseeData.name}
              onChange={handleChangeLesseeData}
              name={'name'}
              placeholder={'Name'}
              errorMess={errors.name}
            />
          </Col>
          <Col md='6'>
            <CustomInputText
              label='Company Owner'
              value={lesseeData.ownerName}
              onChange={handleChangeLesseeData}
              name={'ownerName'}
              placeholder={'Company Owner'}
              errorMess={errors.ownerName}
            />
          </Col>
        </Row>
        <Row className='mt-2'>
          <Col md='6'>
            <CustomInputText
              label='Street'
              value={lesseeData.addressStreet1}
              onChange={handleChangeLesseeData}
              name={'addressStreet1'}
              placeholder={'Street'}
              errorMess={errors.addressStreet1}
            />
          </Col>
          <Col md='6'>
            <CustomInputText
              label='City'
              value={lesseeData.addressCity}
              onChange={handleChangeLesseeData}
              name={'addressCity'}
              placeholder={'City'}
              errorMess={errors.addressCity}
            />
          </Col>
        </Row>
        <Row className='mt-2'>
          <Col md='6'>
            <CustomInputText
              label='Zip'
              value={lesseeData.addressZip}
              onChange={handleChangeLesseeData}
              name={'addressZip'}
              placeholder={'Zip'}
              errorMess={errors.addressZip}
            />
          </Col>
          <Col md='6'>
            <CustomSelect
              isMulti={false}
              label='State'
              placeholder='Please select...'
              name='addressState'
              onChange={handleChangeLesseeDataSelect}
              defaultValue={lesseeData.addressState || 0}
              options={stateOptions}
              isClearable
              invalid={!!errors.addressState}
              errorMess={errors.addressState}
            />
          </Col>
        </Row>
        <Row className='mt-2'>
          <Col md='6'>
            <CustomInputMask
              label='Business Phone'
              value={lesseeData.businessPhone}
              onChange={handleChangeLesseeData}
              name={'businessPhone'}
              placeholder={'Business Phone'}
              errorMess={errors.businessPhone}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <Row className='d-flex justify-content-end pr-3'>
          <Button className='btn btn-sm btn-gold' onClick={saveLessee}>
            Save
          </Button>
          <Button className='btn btn-sm btn-danger ml-2' onClick={toggleModal}>
            Cancel
          </Button>
        </Row>
      </CustomModal>
    </>
  )
}

export default ChangeLessee
